import { render, staticRenderFns } from "./JobPreview.vue?vue&type=template&id=f0866a54&scoped=true"
import script from "./JobPreview.vue?vue&type=script&lang=js"
export * from "./JobPreview.vue?vue&type=script&lang=js"
import style0 from "./JobPreview.vue?vue&type=style&index=0&id=f0866a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0866a54",
  null
  
)

export default component.exports